import { TOGGLE_USER_STATUS_REQUEST, TOGGLE_USER_STATUS_SUCCESS, TOGGLE_USER_STATUS_FAILURE, } from "../Types";
  
  const initialState = {
    loading: false,
    error: null,
    successMessage: null,
    updatedUser: null,
  };
  
  const ActivDesactivUtilisateursReducer = (state = initialState, action) => {
    switch (action.type) {
      case TOGGLE_USER_STATUS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
          successMessage: null,
        };
  
      case TOGGLE_USER_STATUS_SUCCESS:
        return {
          ...state,
          loading: false,
          successMessage: action.payload.message,
          updatedUser: action.payload.utilisateur || null, 
        };
  
      case TOGGLE_USER_STATUS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
          successMessage: null,
        };
  
      default:
        return state;
    }
  };
  
  export default ActivDesactivUtilisateursReducer;
  